import { root } from 'app/store/constants';

const TYPE_SWITCHER_EXPANDED_WIDTH = 1200; //px

export const isExpandedSwitcher = (
): boolean => {
    return root._innerWidth > TYPE_SWITCHER_EXPANDED_WIDTH;
};
